<template>
  <!-- MODAL EDIT -->
  <b-modal
    :id="'SelectSolution'+idData"
    ref="my-modal"
    title="เลือกอุปกรณ์"
    size="huge"
    ok-title="ตกลง"
    cancel-title="ยกเลิก"
    @ok="selectEQ"
  >
    <b-row>
      <b-col
        cols="12"
        class="mb-1"
      >
        <b-table
          ref="selectableTable"
          responsive
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          selectable
          @filtered="onFiltered"
          @row-selected="onRowSelected"
        >
          <template
            #cell(group_name)="data"
          >
            <span style="color:black; font-weight: bold;">{{ data.item.group_name }}</span>
          </template>
          <template
            #cell(ipaddress)="data"
          >
            <span style="color:black; font-weight: bold;">{{ data.item.ipaddress }}</span>
          </template>
          <template
            #cell(hostname)="data"
          >
            <span style="color:black; font-weight: bold;">{{ data.item.hostname }}</span>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BTable,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,

  },
  props: {
    idData: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'group_name',
          label: 'ประเภท',
          class: 'text-center',
        },
        {
          key: 'ipaddress',
          label: 'ipaddress',
          sortable: true,
        },
        {
          key: 'hostname',
          label: 'DESC',
          class: 'text-center',
        },
      ],
      items: [],
      perPage: 99999,
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      modalID: 0,
      selected: [],
      onlyEQ: [],
      sg_id: '',
    }
  },
  mounted() {
  },
  methods: {
    onRowSelected(items) {
      this.selected = items
      this.onlyEQ.splice(0)
      this.selected.forEach(value => {
        this.onlyEQ.push(value.eq_id)
      })
      console.log(this.onlyEQ)
    },
    getSumEquipment(value) {
      this.sg_id = value
      axios
        .post('/sumEquipment', { pj_code: this.$route.query.pj_code, location_id: 0 })
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
          this.$emit('fetch')
        })
        .catch(error => {
          console.log(error)
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    async selectEQ() {
      axios
        .post('/addESolution', { sg_id: this.sg_id, eq_id: this.onlyEQ })
        .then(response => {
          console.log(response)
          this.$swal({
            icon: 'success',
            title: '<span style="color:#000000">แก้ไขข้อมูลเรียบร้อย.</span>',
            showConfirmButton: false,
            timer: 1000,
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.text-custom {
  color: blue; /* Change this to your desired color */
}
</style>
